import { setLoading } from "../redux/app_global/reducer";
import { setLoading as setLoadingPosts, setPosts_id, setPosts_list, setCategory_id, setCategory_list, setCategory_category_list } from "../redux/posts/reducer";
import Request, { RequestFile } from "./handler.js";

//@ Посты
export const getPostsSeo = async (data) => {
    var result = {};
    
    data.method = 'posts_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getPostsList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setPosts_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const getPostsId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'posts_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setPosts_id(json?.result));
            } else {
                await dispatch(setPosts_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const addPosts = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsContent = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_upd_content';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsSeo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_upd_seo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const delPostsPhoto = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_del_photo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const delPostsPhotoBig = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_del_photo_big';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

//@ Категории
export const getPostsCategorySeo = async (data) => {
    var result = {};
    
    data.method = 'posts_category_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getPostsCategoryList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setCategory_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const getPostsCategoryCategoryList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_category_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setCategory_category_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const getPostsCategoryId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'posts_category_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setCategory_id(json?.result));
            } else {
                await dispatch(setCategory_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const addPostsCategory = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsCategoryData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsCategoryContent = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_upd_content';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const updPostsCategorySeo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_upd_seo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const delPostsCategoryPhoto = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_del_photo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}

export const delPostsCategoryPhotoBig = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingPosts(true));
    data.method = 'posts_category_del_photo_big';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingPosts(false));

    return result;
}